// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* DeveloperPortal.css - Discord-Style Meci Developer Portal */

.dev-portal {
  position: fixed;
  inset: 0;
  z-index: 9999;
  background: #0f1117;
  color: #dbdee1;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* Header Navbar */
.dev-navbar {
  height: 56px;
  background: #18191c;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  flex-shrink: 0;
  z-index: 100;
}

.dev-nav-brand {
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
}

.dev-logo-mark {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: linear-gradient(135deg, #5865F2, #3b82f6);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-weight: 800;
  font-size: 16px;
  box-shadow: 0 2px 10px rgba(88, 101, 242, 0.4);
}

.dev-brand-title {
  font-size: 16px;
  font-weight: 800;
  color: #fff;
  letter-spacing: -0.2px;
}

.dev-brand-badge {
  font-size: 10px;
  font-weight: 800;
  background: rgba(88, 101, 242, 0.2);
  color: #7983f5;
  border: 1px solid rgba(88, 101, 242, 0.4);
  padding: 2px 7px;
  border-radius: 4px;
  letter-spacing: 0.5px;
}

.dev-nav-links {
  display: flex;
  align-items: center;
  gap: 6px;
}

.dev-nav-link {
  background: transparent;
  border: none;
  color: #949ba4;
  font-size: 14px;
  font-weight: 600;
  padding: 8px 14px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.15s ease;
  display: flex;
  align-items: center;
  gap: 6px;
}

.dev-nav-link:hover {
  color: #fff;
  background: rgba(255, 255, 255, 0.05);
}

.dev-nav-link.active {
  color: #fff;
  background: rgba(255, 255, 255, 0.1);
}

.dev-nav-user {
  display: flex;
  align-items: center;
  gap: 12px;
}

.dev-back-app-btn {
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.12);
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  padding: 6px 14px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.15s ease;
  display: flex;
  align-items: center;
  gap: 6px;
}

.dev-back-app-btn:hover {
  background: rgba(255, 255, 255, 0.15);
}

/* Main Container */
.dev-container {
  flex: 1;
  display: flex;
  overflow: hidden;
}

/* Applications Overview Page */
.dev-apps-view {
  flex: 1;
  overflow-y: auto;
  padding: 36px 48px;
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
}

.dev-apps-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
}

.dev-apps-title-area h1 {
  font-size: 26px;
  font-weight: 800;
  color: #fff;
  margin: 0 0 6px 0;
}

.dev-apps-title-area p {
  margin: 0;
  font-size: 14px;
  color: #949ba4;
}

.dev-apps-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.dev-limit-pill {
  font-size: 12px;
  font-weight: 700;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.1);
  padding: 6px 12px;
  border-radius: 20px;
  color: #b5bac1;
}

.dev-new-app-btn {
  background: #5865F2;
  border: none;
  color: #fff;
  font-size: 13px;
  font-weight: 700;
  padding: 9px 18px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.15s ease;
  display: flex;
  align-items: center;
  gap: 6px;
  box-shadow: 0 4px 14px rgba(88, 101, 242, 0.35);
}

.dev-new-app-btn:hover {
  background: #4752c4;
}

.dev-new-app-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Apps Grid */
.dev-apps-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 16px;
  margin-top: 16px;
}

.dev-app-card {
  background: #18191c;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  padding: 18px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);
  position: relative;
  overflow: hidden;
}

.dev-app-card:hover {
  border-color: rgba(88, 101, 242, 0.6);
  transform: translateY(-2px);
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.4);
}

.dev-app-card-top {
  display: flex;
  align-items: center;
  gap: 12px;
}

.dev-app-avatar {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background: #2b2d31;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: 700;
  color: #fff;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.1);
  flex-shrink: 0;
}

.dev-app-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.dev-app-meta {
  flex: 1;
  overflow: hidden;
}

.dev-app-name-row {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 2px;
}

.dev-app-name {
  font-size: 15px;
  font-weight: 700;
  color: #fff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dev-bot-badge {
  background: #5865F2;
  color: #fff;
  font-size: 9px;
  font-weight: 800;
  padding: 2px 5px;
  border-radius: 4px;
  letter-spacing: 0.5px;
}

.dev-app-client-id {
  font-size: 11px;
  color: #949ba4;
  font-family: monospace;
}

.dev-app-desc {
  font-size: 12px;
  color: #949ba4;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  min-height: 34px;
}

.dev-app-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 10px;
  border-top: 1px solid rgba(255, 255, 255, 0.05);
  font-size: 11px;
  color: #80848e;
}

.dev-manage-pill {
  color: #7983f5;
  font-weight: 600;
  font-size: 12px;
  display: flex;
  align-items: center;
  gap: 4px;
}

/* Empty State */
.dev-empty-state {
  text-align: center;
  padding: 60px 20px;
  background: rgba(255, 255, 255, 0.02);
  border: 2px dashed rgba(255, 255, 255, 0.08);
  border-radius: 16px;
  margin-top: 24px;
}

.dev-empty-icon {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: rgba(88, 101, 242, 0.15);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 16px auto;
  color: #5865F2;
}

.dev-empty-state h3 {
  font-size: 18px;
  color: #fff;
  margin: 0 0 8px 0;
}

.dev-empty-state p {
  color: #949ba4;
  max-width: 420px;
  margin: 0 auto 20px auto;
  font-size: 14px;
  line-height: 1.5;
}

/* Detail View Layout */
.dev-detail-layout {
  flex: 1;
  display: flex;
  overflow: hidden;
}

.dev-sidebar {
  width: 260px;
  background: #18191c;
  border-right: 1px solid rgba(255, 255, 255, 0.08);
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
}

.dev-sidebar-header {
  padding: 20px 18px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  display: flex;
  align-items: center;
  gap: 12px;
}

.dev-sidebar-avatar {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: #2b2d31;
  overflow: hidden;
}

.dev-sidebar-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.dev-sidebar-name {
  font-size: 14px;
  font-weight: 700;
  color: #fff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dev-sidebar-nav {
  padding: 12px 8px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
}

.dev-sidebar-btn {
  background: transparent;
  border: none;
  color: #949ba4;
  font-size: 13px;
  font-weight: 600;
  padding: 10px 14px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.15s ease;
  display: flex;
  align-items: center;
  gap: 10px;
  text-align: left;
}

.dev-sidebar-btn:hover {
  background: rgba(255, 255, 255, 0.05);
  color: #fff;
}

.dev-sidebar-btn.active {
  background: rgba(88, 101, 242, 0.2);
  color: #fff;
  border-left: 3px solid #5865F2;
}

.dev-sidebar-danger {
  padding: 16px;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
}

.dev-delete-app-btn {
  width: 100%;
  background: rgba(239, 68, 68, 0.1);
  border: 1px solid rgba(239, 68, 68, 0.25);
  color: #ef4444;
  font-size: 12px;
  font-weight: 700;
  padding: 9px;
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  transition: all 0.15s ease;
}

.dev-delete-app-btn:hover {
  background: rgba(239, 68, 68, 0.2);
}

/* Detail Content Area */
.dev-detail-content {
  flex: 1;
  overflow-y: auto;
  padding: 36px 48px;
  max-width: 960px;
}

.dev-content-header {
  margin-bottom: 28px;
}

.dev-content-header h2 {
  font-size: 22px;
  font-weight: 800;
  color: #fff;
  margin: 0 0 6px 0;
}

.dev-content-header p {
  margin: 0;
  font-size: 13px;
  color: #949ba4;
}

/* Forms & Fields */
.dev-form-card {
  background: #18191c;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 24px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.dev-field-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.dev-label {
  font-size: 12px;
  font-weight: 700;
  color: #b5bac1;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.dev-input {
  background: #2b2d31;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 6px;
  padding: 10px 14px;
  color: #fff;
  font-size: 14px;
  outline: none;
  transition: border-color 0.15s ease;
}

.dev-input:focus {
  border-color: #5865F2;
}

.dev-textarea {
  min-height: 80px;
  resize: vertical;
}

.dev-secret-box {
  display: flex;
  align-items: center;
  gap: 8px;
}

.dev-secret-input {
  flex: 1;
  background: #1e1f22;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 6px;
  padding: 10px 14px;
  font-family: monospace;
  font-size: 13px;
  color: #7983f5;
}

.dev-btn-secondary {
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.12);
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  padding: 9px 14px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.15s ease;
  display: flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
}

.dev-btn-secondary:hover {
  background: rgba(255, 255, 255, 0.14);
}

.dev-save-bar {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 16px;
}

/* Permissions Grid */
.dev-permissions-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 12px;
  margin-top: 10px;
}

.dev-checkbox-card {
  background: #2b2d31;
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 8px;
  padding: 12px 14px;
  display: flex;
  align-items: flex-start;
  gap: 10px;
  cursor: pointer;
  transition: all 0.15s ease;
}

.dev-checkbox-card:hover {
  background: rgba(255, 255, 255, 0.08);
}

.dev-checkbox-card input[type="checkbox"] {
  accent-color: #5865F2;
  width: 16px;
  height: 16px;
  margin-top: 2px;
  cursor: pointer;
}

.dev-checkbox-card .perm-text {
  display: flex;
  flex-direction: column;
}

.dev-checkbox-card .perm-title {
  font-size: 13px;
  font-weight: 600;
  color: #fff;
}

.dev-checkbox-card .perm-desc {
  font-size: 11px;
  color: #949ba4;
  margin-top: 2px;
}

/* Code Snippet Box */
.dev-code-card {
  background: #111214;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 10px;
  overflow: hidden;
  margin-top: 12px;
}

.dev-code-header {
  background: #1e1f22;
  padding: 8px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}

.dev-code-lang {
  font-size: 11px;
  font-weight: 700;
  color: #949ba4;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.dev-code-copy-btn {
  background: transparent;
  border: none;
  color: #949ba4;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 3px 6px;
  border-radius: 4px;
}

.dev-code-copy-btn:hover {
  color: #fff;
  background: rgba(255, 255, 255, 0.08);
}

.dev-code-pre {
  margin: 0;
  padding: 16px;
  overflow-x: auto;
  font-family: Consolas, Monaco, "Courier New", monospace;
  font-size: 13px;
  line-height: 1.5;
  color: #e3e5e8;
}

/* Modal */
.dev-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  animation: devFadeIn 0.15s ease;
}

.dev-modal-box {
  width: 480px;
  max-width: 92vw;
  background: #18191c;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.7);
  display: flex;
  flex-direction: column;
}

.dev-modal-header {
  padding: 20px 24px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.dev-modal-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 800;
  color: #fff;
}

.dev-modal-body {
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.dev-modal-footer {
  padding: 16px 24px;
  background: #111214;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

@keyframes devFadeIn {
  from { opacity: 0; transform: scale(0.97); }
  to { opacity: 1; transform: scale(1); }
}
`, "",{"version":3,"sources":["webpack://./src/components/DeveloperPortal/DeveloperPortal.css"],"names":[],"mappings":"AAAA,8DAA8D;;AAE9D;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,gGAAgG;EAChG,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,YAAY;EACZ,mBAAmB;EACnB,kDAAkD;EAClD,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,cAAc;EACd,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qDAAqD;EACrD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mCAAmC;EACnC,cAAc;EACd,yCAAyC;EACzC,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,qCAAqC;AACvC;;AAEA,mBAAmB;AACnB;EACE,OAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA,+BAA+B;AAC/B;EACE,OAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qCAAqC;EACrC,0CAA0C;EAC1C,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;EACf,kDAAkD;EAClD,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,OAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,+CAA+C;EAC/C,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,qCAAqC;EACrC,4CAA4C;EAC5C,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,OAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,iDAAiD;EACjD,aAAa;EACb,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kDAAkD;EAClD,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,OAAO;AACT;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,mCAAmC;EACnC,WAAW;EACX,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,kCAAkC;EAClC,yCAAyC;EACzC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,0BAA0B;AAC5B;;AAEA;EACE,kCAAkC;AACpC;;AAEA,wBAAwB;AACxB;EACE,OAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,aAAa;EACb,mCAAmC;AACrC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,OAAO;EACP,mBAAmB;EACnB,2CAA2C;EAC3C,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA,qBAAqB;AACrB;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kDAAkD;AACpD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,qCAAqC;AACvC;;AAEA;EACE,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,uDAAuD;EACvD,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,UAAU;AACV;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,2CAA2C;EAC3C,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,kDAAkD;EAClD,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,+CAA+C;EAC/C,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,OAAO,UAAU,EAAE,sBAAsB,EAAE;EAC3C,KAAK,UAAU,EAAE,mBAAmB,EAAE;AACxC","sourcesContent":["/* DeveloperPortal.css - Discord-Style Meci Developer Portal */\n\n.dev-portal {\n  position: fixed;\n  inset: 0;\n  z-index: 9999;\n  background: #0f1117;\n  color: #dbdee1;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n/* Header Navbar */\n.dev-navbar {\n  height: 56px;\n  background: #18191c;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 24px;\n  flex-shrink: 0;\n  z-index: 100;\n}\n\n.dev-nav-brand {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  cursor: pointer;\n}\n\n.dev-logo-mark {\n  width: 32px;\n  height: 32px;\n  border-radius: 8px;\n  background: linear-gradient(135deg, #5865F2, #3b82f6);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n  font-weight: 800;\n  font-size: 16px;\n  box-shadow: 0 2px 10px rgba(88, 101, 242, 0.4);\n}\n\n.dev-brand-title {\n  font-size: 16px;\n  font-weight: 800;\n  color: #fff;\n  letter-spacing: -0.2px;\n}\n\n.dev-brand-badge {\n  font-size: 10px;\n  font-weight: 800;\n  background: rgba(88, 101, 242, 0.2);\n  color: #7983f5;\n  border: 1px solid rgba(88, 101, 242, 0.4);\n  padding: 2px 7px;\n  border-radius: 4px;\n  letter-spacing: 0.5px;\n}\n\n.dev-nav-links {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.dev-nav-link {\n  background: transparent;\n  border: none;\n  color: #949ba4;\n  font-size: 14px;\n  font-weight: 600;\n  padding: 8px 14px;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.15s ease;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.dev-nav-link:hover {\n  color: #fff;\n  background: rgba(255, 255, 255, 0.05);\n}\n\n.dev-nav-link.active {\n  color: #fff;\n  background: rgba(255, 255, 255, 0.1);\n}\n\n.dev-nav-user {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.dev-back-app-btn {\n  background: rgba(255, 255, 255, 0.08);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  color: #fff;\n  font-size: 13px;\n  font-weight: 600;\n  padding: 6px 14px;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.15s ease;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.dev-back-app-btn:hover {\n  background: rgba(255, 255, 255, 0.15);\n}\n\n/* Main Container */\n.dev-container {\n  flex: 1;\n  display: flex;\n  overflow: hidden;\n}\n\n/* Applications Overview Page */\n.dev-apps-view {\n  flex: 1;\n  overflow-y: auto;\n  padding: 36px 48px;\n  max-width: 1200px;\n  margin: 0 auto;\n  width: 100%;\n}\n\n.dev-apps-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 24px;\n}\n\n.dev-apps-title-area h1 {\n  font-size: 26px;\n  font-weight: 800;\n  color: #fff;\n  margin: 0 0 6px 0;\n}\n\n.dev-apps-title-area p {\n  margin: 0;\n  font-size: 14px;\n  color: #949ba4;\n}\n\n.dev-apps-actions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.dev-limit-pill {\n  font-size: 12px;\n  font-weight: 700;\n  background: rgba(255, 255, 255, 0.06);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  padding: 6px 12px;\n  border-radius: 20px;\n  color: #b5bac1;\n}\n\n.dev-new-app-btn {\n  background: #5865F2;\n  border: none;\n  color: #fff;\n  font-size: 13px;\n  font-weight: 700;\n  padding: 9px 18px;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.15s ease;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  box-shadow: 0 4px 14px rgba(88, 101, 242, 0.35);\n}\n\n.dev-new-app-btn:hover {\n  background: #4752c4;\n}\n\n.dev-new-app-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Apps Grid */\n.dev-apps-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 16px;\n  margin-top: 16px;\n}\n\n.dev-app-card {\n  background: #18191c;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 12px;\n  padding: 18px;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  cursor: pointer;\n  transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);\n  position: relative;\n  overflow: hidden;\n}\n\n.dev-app-card:hover {\n  border-color: rgba(88, 101, 242, 0.6);\n  transform: translateY(-2px);\n  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.4);\n}\n\n.dev-app-card-top {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.dev-app-avatar {\n  width: 48px;\n  height: 48px;\n  border-radius: 12px;\n  background: #2b2d31;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 20px;\n  font-weight: 700;\n  color: #fff;\n  overflow: hidden;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  flex-shrink: 0;\n}\n\n.dev-app-avatar img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.dev-app-meta {\n  flex: 1;\n  overflow: hidden;\n}\n\n.dev-app-name-row {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-bottom: 2px;\n}\n\n.dev-app-name {\n  font-size: 15px;\n  font-weight: 700;\n  color: #fff;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.dev-bot-badge {\n  background: #5865F2;\n  color: #fff;\n  font-size: 9px;\n  font-weight: 800;\n  padding: 2px 5px;\n  border-radius: 4px;\n  letter-spacing: 0.5px;\n}\n\n.dev-app-client-id {\n  font-size: 11px;\n  color: #949ba4;\n  font-family: monospace;\n}\n\n.dev-app-desc {\n  font-size: 12px;\n  color: #949ba4;\n  line-height: 1.4;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  min-height: 34px;\n}\n\n.dev-app-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding-top: 10px;\n  border-top: 1px solid rgba(255, 255, 255, 0.05);\n  font-size: 11px;\n  color: #80848e;\n}\n\n.dev-manage-pill {\n  color: #7983f5;\n  font-weight: 600;\n  font-size: 12px;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n/* Empty State */\n.dev-empty-state {\n  text-align: center;\n  padding: 60px 20px;\n  background: rgba(255, 255, 255, 0.02);\n  border: 2px dashed rgba(255, 255, 255, 0.08);\n  border-radius: 16px;\n  margin-top: 24px;\n}\n\n.dev-empty-icon {\n  width: 64px;\n  height: 64px;\n  border-radius: 50%;\n  background: rgba(88, 101, 242, 0.15);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto 16px auto;\n  color: #5865F2;\n}\n\n.dev-empty-state h3 {\n  font-size: 18px;\n  color: #fff;\n  margin: 0 0 8px 0;\n}\n\n.dev-empty-state p {\n  color: #949ba4;\n  max-width: 420px;\n  margin: 0 auto 20px auto;\n  font-size: 14px;\n  line-height: 1.5;\n}\n\n/* Detail View Layout */\n.dev-detail-layout {\n  flex: 1;\n  display: flex;\n  overflow: hidden;\n}\n\n.dev-sidebar {\n  width: 260px;\n  background: #18191c;\n  border-right: 1px solid rgba(255, 255, 255, 0.08);\n  display: flex;\n  flex-direction: column;\n  flex-shrink: 0;\n}\n\n.dev-sidebar-header {\n  padding: 20px 18px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.dev-sidebar-avatar {\n  width: 36px;\n  height: 36px;\n  border-radius: 8px;\n  background: #2b2d31;\n  overflow: hidden;\n}\n\n.dev-sidebar-avatar img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.dev-sidebar-name {\n  font-size: 14px;\n  font-weight: 700;\n  color: #fff;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.dev-sidebar-nav {\n  padding: 12px 8px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  flex: 1;\n}\n\n.dev-sidebar-btn {\n  background: transparent;\n  border: none;\n  color: #949ba4;\n  font-size: 13px;\n  font-weight: 600;\n  padding: 10px 14px;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.15s ease;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  text-align: left;\n}\n\n.dev-sidebar-btn:hover {\n  background: rgba(255, 255, 255, 0.05);\n  color: #fff;\n}\n\n.dev-sidebar-btn.active {\n  background: rgba(88, 101, 242, 0.2);\n  color: #fff;\n  border-left: 3px solid #5865F2;\n}\n\n.dev-sidebar-danger {\n  padding: 16px;\n  border-top: 1px solid rgba(255, 255, 255, 0.06);\n}\n\n.dev-delete-app-btn {\n  width: 100%;\n  background: rgba(239, 68, 68, 0.1);\n  border: 1px solid rgba(239, 68, 68, 0.25);\n  color: #ef4444;\n  font-size: 12px;\n  font-weight: 700;\n  padding: 9px;\n  border-radius: 6px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  transition: all 0.15s ease;\n}\n\n.dev-delete-app-btn:hover {\n  background: rgba(239, 68, 68, 0.2);\n}\n\n/* Detail Content Area */\n.dev-detail-content {\n  flex: 1;\n  overflow-y: auto;\n  padding: 36px 48px;\n  max-width: 960px;\n}\n\n.dev-content-header {\n  margin-bottom: 28px;\n}\n\n.dev-content-header h2 {\n  font-size: 22px;\n  font-weight: 800;\n  color: #fff;\n  margin: 0 0 6px 0;\n}\n\n.dev-content-header p {\n  margin: 0;\n  font-size: 13px;\n  color: #949ba4;\n}\n\n/* Forms & Fields */\n.dev-form-card {\n  background: #18191c;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 12px;\n  padding: 24px;\n  margin-bottom: 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.dev-field-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.dev-label {\n  font-size: 12px;\n  font-weight: 700;\n  color: #b5bac1;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.dev-input {\n  background: #2b2d31;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 6px;\n  padding: 10px 14px;\n  color: #fff;\n  font-size: 14px;\n  outline: none;\n  transition: border-color 0.15s ease;\n}\n\n.dev-input:focus {\n  border-color: #5865F2;\n}\n\n.dev-textarea {\n  min-height: 80px;\n  resize: vertical;\n}\n\n.dev-secret-box {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.dev-secret-input {\n  flex: 1;\n  background: #1e1f22;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 6px;\n  padding: 10px 14px;\n  font-family: monospace;\n  font-size: 13px;\n  color: #7983f5;\n}\n\n.dev-btn-secondary {\n  background: rgba(255, 255, 255, 0.08);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  color: #fff;\n  font-size: 13px;\n  font-weight: 600;\n  padding: 9px 14px;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.15s ease;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  white-space: nowrap;\n}\n\n.dev-btn-secondary:hover {\n  background: rgba(255, 255, 255, 0.14);\n}\n\n.dev-save-bar {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  margin-top: 16px;\n}\n\n/* Permissions Grid */\n.dev-permissions-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));\n  gap: 12px;\n  margin-top: 10px;\n}\n\n.dev-checkbox-card {\n  background: #2b2d31;\n  border: 1px solid rgba(255, 255, 255, 0.06);\n  border-radius: 8px;\n  padding: 12px 14px;\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.dev-checkbox-card:hover {\n  background: rgba(255, 255, 255, 0.08);\n}\n\n.dev-checkbox-card input[type=\"checkbox\"] {\n  accent-color: #5865F2;\n  width: 16px;\n  height: 16px;\n  margin-top: 2px;\n  cursor: pointer;\n}\n\n.dev-checkbox-card .perm-text {\n  display: flex;\n  flex-direction: column;\n}\n\n.dev-checkbox-card .perm-title {\n  font-size: 13px;\n  font-weight: 600;\n  color: #fff;\n}\n\n.dev-checkbox-card .perm-desc {\n  font-size: 11px;\n  color: #949ba4;\n  margin-top: 2px;\n}\n\n/* Code Snippet Box */\n.dev-code-card {\n  background: #111214;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 10px;\n  overflow: hidden;\n  margin-top: 12px;\n}\n\n.dev-code-header {\n  background: #1e1f22;\n  padding: 8px 16px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.05);\n}\n\n.dev-code-lang {\n  font-size: 11px;\n  font-weight: 700;\n  color: #949ba4;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.dev-code-copy-btn {\n  background: transparent;\n  border: none;\n  color: #949ba4;\n  cursor: pointer;\n  font-size: 12px;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  padding: 3px 6px;\n  border-radius: 4px;\n}\n\n.dev-code-copy-btn:hover {\n  color: #fff;\n  background: rgba(255, 255, 255, 0.08);\n}\n\n.dev-code-pre {\n  margin: 0;\n  padding: 16px;\n  overflow-x: auto;\n  font-family: Consolas, Monaco, \"Courier New\", monospace;\n  font-size: 13px;\n  line-height: 1.5;\n  color: #e3e5e8;\n}\n\n/* Modal */\n.dev-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.7);\n  backdrop-filter: blur(4px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10000;\n  animation: devFadeIn 0.15s ease;\n}\n\n.dev-modal-box {\n  width: 480px;\n  max-width: 92vw;\n  background: #18191c;\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  border-radius: 14px;\n  overflow: hidden;\n  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.7);\n  display: flex;\n  flex-direction: column;\n}\n\n.dev-modal-header {\n  padding: 20px 24px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.dev-modal-header h3 {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 800;\n  color: #fff;\n}\n\n.dev-modal-body {\n  padding: 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.dev-modal-footer {\n  padding: 16px 24px;\n  background: #111214;\n  border-top: 1px solid rgba(255, 255, 255, 0.06);\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n}\n\n@keyframes devFadeIn {\n  from { opacity: 0; transform: scale(0.97); }\n  to { opacity: 1; transform: scale(1); }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
